import React, {Component} from 'react';

class NotFoundPage extends Component {
 
  render() {
 
  	return (
       <div>
           <h2>Página no existe</h2>
       </div>
  	)
    
  }
 
}
 
export default NotFoundPage;